import * as React from "react"
import { SvgStars01 } from "@digits-shared/components/SVGIcons/line/Stars01.svg"
import { DigitsLinkButton } from "@digits-shared/DesignSystem/LinkButton"
import { AspectCode } from "@digits-shared/session/AspectCode"
import styled from "styled-components"
import { RequiresComment } from "src/frontend/components/Shared/Permissions/Requires"
import { RequiresAspect } from "src/frontend/components/Shared/Permissions/RequiresAspect"
import { useFrontendPathGenerator } from "src/frontend/hooks/useFrontendPathGenerator"
import routes from "src/frontend/routes"
import {
  FrontendPermissionModule,
  FrontendPermissionSource,
} from "src/frontend/session/permissionModule"

/*
  STYLES
*/

const AssistantIcon = styled(SvgStars01)`
  width: 16px;
  height: 16px;
`

/*
  COMPONENTS
*/
export const AssistantHeaderButton: React.FC = () => {
  const generatePath = useFrontendPathGenerator()

  return (
    <RequiresAspect aspect={AspectCode.AskDigits}>
      <RequiresComment
        source={FrontendPermissionSource.LegalEntity}
        module={FrontendPermissionModule.Portals}
      >
        <DigitsLinkButton
          size="medium"
          $variant="secondary-white"
          to={generatePath(routes.legalEntityHomeAssistant)}
          $circle
        >
          <AssistantIcon />
        </DigitsLinkButton>
      </RequiresComment>
    </RequiresAspect>
  )
}
